import React from 'react';
import { useLocation } from 'react-router-dom';
import './Invoice.css';
import Sidebar from './sidebar';

const Invoice = () => {
  const location = useLocation();
  const { order, products } = location.state || { order: [], products: [] };

  // Вычисляем итоги
  const totalQuantity = products.reduce((acc, product) => acc + product.quantity, 0);
  const totalPrice = products.reduce((acc, product) => acc + product.total, 0);

  // Выводим данные для отладки
  console.log("Order:", order);
  console.log("Products:", products);
  console.log("Total Quantity:", totalQuantity);
  console.log("Total Price:", totalPrice);

  return (
    <div className="container">
      <Sidebar />
      <div className="invoice-content">
        <div className="document-info">
          <div>Приложение 26</div>
          <div>к приказу Министра финансов</div>
          <div>Республики Казахстан</div>
          <div>от 20 декабря 2012 года № 562</div>
          <div>Форма 3-2</div>
          <div>ИИН/БИН</div>
          <div>{order[0]?.client_bin || ''}</div>
        </div>
        <div className="invoice-header">
          <div className="header-left">
            <div>Организация (индивидуальный предприниматель)____________________</div>
          </div>
          <div className="header-right">
          </div>
        </div>

        <div className="document-number">
          <div className="number">
            <div>Номер документа</div>
            <div>{order[0]?.order_number || ''}</div>
          </div>
          <div className="date">
            <div>Дата составления</div>
            <div>{new Date().toLocaleDateString()}</div>
          </div>
        </div>

        <h2>НАКЛАДНАЯ НА ОТПУСК ЗАПАСОВ НА СТОРОНУ</h2>

        <div className="table">
          <div className="row header-row">
            <div className="cell">Организация (индивидуальный предприниматель) - отправитель</div>
            <div className="cell">Организация (индивидуальный предприниматель) - получатель</div>
            <div className="cell">Ответственный за поставку (Ф.И.О.)</div>
            <div className="cell">Транспортная организация</div>
          </div>
          <div className="row">
            <div className="cell">МБ4</div>
            <div className="cell">{order[0]?.client_name || ''}</div>
            <div className="cell">{order[0]?.driver_name || ''}</div>
            <div className="cell">??????</div>
          </div>
        </div>

        <div className="table">
          <div className="row header-row">
            <div className="cell">Номер по порядку</div>
            <div className="cell">Наименование, характеристика</div>
            <div className="cell">Номенклатурный номер</div>
            <div className="cell">Единица измерения</div>
            <div className="cell">подлежит отпуску</div>
            <div className="cell">отпущено</div>
            <div className="cell">Цена за единицу, в KZT</div>
            <div className="cell">Сумма с НДС, в KZT</div>
            <div className="cell">Сумма НДС, в KZT</div>
          </div>
          {products.map((product, index) => (
            <div className="row" key={product.id}>
              <div className="cell">{index + 1}</div>
              <div className="cell">{product.product_name}</div>
              <div className="cell">{product.product_code}</div>
              <div className="cell">{product.measure_name}</div>
              <div className="cell">{product.quantity}</div>
              <div className="cell">{product.quantity}</div>
              <div className="cell">{product.price}</div>
              <div className="cell">{product.total}</div>
              <div className="cell">0.00</div>
            </div>
          ))}
          <div className="row-total">
            <div className="cell">Итого</div>
            <div className="cell"></div>
            <div className="cell"></div>
            <div className="cell"></div>
            <div className="cell">{totalQuantity}</div>
            <div className="cell">{totalQuantity}</div>
            <div className="cell">x</div>
            <div className="cell">{totalPrice}</div>
            <div className="cell">0.00</div>
          </div>
        </div>

        <div className="total">
          <div>Всего отпущено количество запасов (прописью): девятьсот восемь</div>
          <div>на сумму (прописью), в KZT: восемьдесят восемь тысяч тенге 00 тиын</div>
        </div>

        <div className="signatures">
          <div className="signature">
            <div>Отпуск разрешил</div>
            <div>Бухгалтер</div>
            <div>___________________</div>
            <div>должность</div>
            <div>подпись</div>
          </div>
          <div className="signature">
            <div>Астахов К.У.</div>
            <div>___________________</div>
            <div>расшифровка подписи</div>
          </div>
          <div className="signature">
            <div>Главный бухгалтер</div>
            <div>не предусмотрен</div>
            <div>___________________</div>
            <div>подпись</div>
            <div>расшифровка подписи</div>
          </div>
          <div className="signature">
            <div>По доверенности</div>
            <div>___________________</div>
            <div>выданной</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
